import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './info-menu.module.css';

const InfoMenu = ({ infoMenuItems }) => {
  const renderMenuItems = () => {
    if (infoMenuItems.length) {
      return infoMenuItems.map((item, index) => {
        return (
          <li key={index} className={styles.item}>
            <a
              href={`https://www.jkdesign.com${item.url}`}
              className={styles.link}
            >
              {item.title}
            </a>
          </li>
        );
      });
    }
  };

  return <ul className={styles.list}>{renderMenuItems()}</ul>;
};

InfoMenu.propTypes = {
  infoMenuItems: PropTypes.array,
};

export default InfoMenu;



// WEBPACK FOOTER //
// ./src/components/menus/info-menu/index.js